export interface SipBusyState {
    readonly ongoingCalls: number;
    readonly groupCallActive: boolean;
}

export const SIP_BUSY_HERE = {status_code: 486, reason_phrase: 'Busy Here'} as const;

export const isSipBusy = ({ongoingCalls, groupCallActive}: SipBusyState): boolean =>
    ongoingCalls > 0 || groupCallActive;

export const shouldRejectIncomingSipAsBusy = (direction: string | undefined, groupCallActive: boolean, ongoingSipCalls = 0): boolean =>
    direction === 'incoming' && (groupCallActive || ongoingSipCalls > 0);
